import { AnyAction } from "redux";

import type { Conversation } from "@twilio/conversations";
import { ThunkDispatch } from "redux-thunk";
import { sessionDataHandler } from "../../sessionDataHandler";
import { ChatReducer } from "../chat.reducer";
import { EngagementPhase } from "../definitions";
import { SessionReducer } from "../session.reducer";
import {
    changeEngagementPhase,
    changeExpandedStatus,
    resetBotData,
    resetChatState,
    clearPreEngagementData
} from "./genericActions";

export function endSession(botName: string, conversation?: Conversation, close?: boolean, nextPhase: EngagementPhase = EngagementPhase.PreEngagementForm) {
    return async (dispatch: ThunkDispatch<ChatReducer | SessionReducer, unknown, AnyAction>) => {
        // Clearing state data
        dispatch(clearPreEngagementData());
        if (close) {
            dispatch(changeExpandedStatus({ expanded: false }));
        }

        dispatch(changeEngagementPhase({ phase: nextPhase }));
        dispatch(resetBotData());
        dispatch(resetChatState());

        // Ending the conversation if one has been created
        if (conversation) {
            await sessionDataHandler.endChat(conversation.sid, botName);
        }
        
        // Clearing session data
        sessionDataHandler.clear();
    };
}
